import type { FaireProductEntity } from "../../entity_types/product";

export const p_zufwgzbqbt: FaireProductEntity = {
  token: "p_zufwgzbqbt",
  type: "product",
  name: "Backgammon Mangowood Game Set",
  brandToken: "b_6xvu4qtx",
  brandName: "Verve Culture",
  imageUrl:
    "https://cdn.faire.com/fastly/92c9c2c3989183a39b95c78fdcdd4e816f16959e5d042ddc2d0d1801bd82c95e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8cda288f0faccbc3168b283e2a3a0383032bad03236327c9c616371d87a7c123.jpeg",
    "https://cdn.faire.com/fastly/35f77f18ca57e2788fb50cce7360590d6da4f74417a8951a6a3bc891ff0b8b0b.jpeg",
    "https://cdn.faire.com/fastly/7d0983434d2210b9d47453d1f720c5530aaa804aed57c15386571c2fb827090e.jpeg",
    "https://cdn.faire.com/fastly/32e946068101a5395c21949d1630fde9ec413463dca5e51985672208f16eaae7.jpeg",
    "https://cdn.faire.com/fastly/67c62ffb5ced4fd597876cbb3fc471c2c2a82525f16c86fa522700b3d939d7ed.jpeg",
    "https://cdn.faire.com/fastly/4c47a5389840301366a905b4ef7021d85789a13b12f80f14873f5a1d8038c1aa.jpeg",
  ],
  priceDollars: 22.5,
  description:
    "Backgammon, one of the oldest known board games, continues to captivate players with its blend of strategy and luck. Its origins trace back approximately 5,000 years to the ancient civilizations of Mesopotamia. This timeless game has evolved through various cultures and eras, each contributing unique elements to its development. The Verve Culture Backgammon Set features handmade wooden pieces and a mangowood box.\n\nToday, backgammon is enjoyed worldwide, maintaining its status as a beloved pastime that combines the ancient art of strategic planning with the unpredictability of the dice roll. Its enduring appeal lies in the game's elegant simplicity, dynamic complexity, and the rich history that Verve Culture’s backgammon set now proudly embodies.\n\nFolded Dimensions - 12'' x 6.5'' x 2.25''\nUnfolded Dimensions -12'' x 13'' x 1''",
  tags: [],
  msrpDollars: 45,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-05T16:55:02.284Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
